/**
 * @file PublicFooter.tsx
 * @description Minimal footer with links to the legal pages and a
 *   "version" stamp matching the active policy version. Mounted at the
 *   bottom of the LandingPage and the AuthLayout so unauthenticated
 *   users always see where to find the Privacy Policy and Terms before
 *   they sign in.
 * @module Components
 * @security No user input. The footer is static.
 */

import type { JSX } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function PublicFooter(): JSX.Element {
  const { t } = useTranslation();
  return (
    <footer className="px-6 py-4 border-t border-slate-200 text-xs text-slate-500 flex flex-wrap justify-center gap-x-4 gap-y-1">
      <Link
        to="/privacy"
        className="hover:underline hover:text-slate-700 transition-colors rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-brand"
      >
        {t('common.privacy_link')}
      </Link>
      <Link
        to="/terms"
        className="hover:underline hover:text-slate-700 transition-colors rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-brand"
      >
        {t('common.terms_link')}
      </Link>
      <span>{t('common.footer_version', { date: t('privacy_policy.effective_date') })}</span>
    </footer>
  );
}
